export function handleUnexpectedError(xhr?: any, status?: string, error?: any) {
  if (xhr) {
    console.error("AJAX XHR: ", xhr);
  }
  if (status) {
    console.error("AJAX status:", status);
  }
  if (error) {
    console.error("AJAX error:", error);
  }
  $(".error-overlay").addClass("show");
}
